import { render } from "./itemTextarea.vue?vue&type=template&id=515ede00&scoped=true"
import script from "./itemTextarea.vue?vue&type=script&lang=js"
export * from "./itemTextarea.vue?vue&type=script&lang=js"

import "./itemTextarea.vue?vue&type=style&index=0&id=515ede00&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/emblematic.es/tour.emblematic.es/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515ede00"]])

export default __exports__